import { ATTENDEE_EVENTS, USER_EVENTS } from "../constants/authConstants";

const initialState = {
  organizerEvents: [],
  attendeeEvents: [],
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_EVENTS:
      return {
        organizerEvents: action.payload.organizerEvents,
        attendeeEvents: action.payload.attendeeEvents,
      };
    case ATTENDEE_EVENTS:
      return {
        attendeeEvents: action.payload.events,
      };

    default:
      return state;
  }
};

export default authReducer;
